/**
 * While the session and the person load (canvas 03-boot): the app's mark, its
 * name, and the sentence that says what is being waited for. The mark is the
 * loader (`BootMark`): the icon's three blocks rise and sink. The phone's boot
 * screen is the same three (`apps/mobile/src/components/boot-splash.tsx`), its
 * mark drawn from the same frames (`packages/ui/src/components/boot-mark.tsx`).
 *
 * Exported for the gate's splash (`~/app/boot-splash.tsx`).
 */
import { t } from '@alluzo/shared';
import type { ReactElement } from 'react';

import { BootMark } from './boot-mark';

export function BootScreen(): ReactElement {
  return (
    <div className="flex h-full items-center justify-center bg-background" role="status" aria-live="polite">
      <div className="flex flex-col items-center gap-6">
        <BootMark />
        <div className="flex flex-col items-center gap-2">
          <span className="type-h4 text-foreground">{t('app.name')}</span>
          <p className="text-sm text-muted-foreground">{t('common.checking_session')}</p>
        </div>
      </div>
    </div>
  );
}
